/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Action performed
 * @export
 */
export const ControlAction = {
    Contain: 'contain',
    Uncontain: 'uncontain'
} as const;
export type ControlAction = typeof ControlAction[keyof typeof ControlAction];


export function ControlActionFromJSON(json: any): ControlAction {
    return ControlActionFromJSONTyped(json, false);
}

export function ControlActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAction {
    return json as ControlAction;
}

export function ControlActionToJSON(value?: ControlAction | null): any {
    return value as any;
}

